<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div class="columns">
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/windows.svg"
                alt="MT4 Windows"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT4 Windows</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt4.windows"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/android.svg"
                alt="MT4 Android"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT4 Android</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt4.android+'='+Language"
                target="_blank"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/ios.svg"
                alt="MT4 iOS"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT4 iOS</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt4.ios"
                target="_blank"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/windows.svg"
                alt="MT5 Windows"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT5 Windows</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt5.windows"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/android.svg"
                alt="MT5 Android"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT5 Android</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt5.android+'='+Language"
                target="_blank"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128">
              <img
                src="../../assets/img/icons/devices/ios.svg"
                alt="MT5 iOS"
              />
            </figure>
          </div>
          <div class="card-content">
            <p class="title">MT5 iOS</p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <a
                class="button is-primary"
                :href="links.mt5.ios"
                target="_blank"
              >{{$t('download').tUpper()}}</a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { service } from '../../app'
import { mapGetters } from 'vuex'
import config from '../../config'

export default {
  data() {
    return {
      links: config.platformDownloadLinks,
      // currencies: config.currencies,
    }
  },

  mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
}
</script>

<style lang="scss" scoped>
.is-128x128 {
  padding-top: 20px;
  margin: 0 auto;
  img {
    max-width: 100px;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// Download.vue?9d205872